var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcShop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-726 -579)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "\\uD0C0\\uC6D0 25",
    cx: 31,
    cy: 31,
    r: 31,
    transform: "translate(726 579)",
    style: {
      fill: "rgba(255,115,29,.1)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 2148"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 763",
    d: "M0 0h41.333v41.333H0z",
    style: {
      fill: "none"
    },
    transform: "translate(736.333 589.333)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 764",
    d: "M5 34V6.444A3.444 3.444 0 0 1 8.444 3h17.223a3.444 3.444 0 0 1 3.444 3.444V34l-5.167-3.444L20.5 34l-3.444-3.444L13.611 34l-3.444-3.444L5 34",
    transform: "translate(739.944 591.5)",
    style: {
      stroke: "#ff731d",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 765",
    d: "M16.889 9.083h-4.306a2.583 2.583 0 1 0 0 5.167h1.722a2.583 2.583 0 1 1 0 5.167H10m3.444 0V22m0-15.5v2.583",
    transform: "translate(743.555 594.027)",
    style: {
      stroke: "#ff731d",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.5px",
      fill: "none"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcShop);
export default __webpack_public_path__ + "static/media/ic-shop.1da113b9.svg";
export { ForwardRef as ReactComponent };